import gql from 'graphql-tag';
import { PaginatorInfoFragment, ProductAllData, CouponCodeAllData } from '../fragments';

export default gql`
query coupon($id: ID!) {
    coupon(id: $id) {
        id
        name
        description
        active_from
        active_to
        type
        applied_to
        is_free_shipping
        generated_codes_count
        used_codes_count
        price_ranges {
            from
            discount
        }
        is_active
        shipping_method {
            id
        }
        payment_method {
            id
        }
        usage_count
        is_combinable
        codes(first: 9999) {
            paginatorInfo {
                total
            }
            data {
                ...CouponCodeAllData
            }
        }
        products(first: 9999) {
            paginatorInfo {
                ...PaginatorInfoFragment
            }
            data {
                ...ProductAllData
            }
        }
    }
}
${PaginatorInfoFragment}
${CouponCodeAllData}
${ProductAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/coupon.ts